import { Button } from "../Button";

import "./index.css";

function BackIcon() {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.7072 13.7929C9.09772 14.1834 9.09772 14.8166 8.7072 15.2071C8.31668 15.5976 7.68351 15.5976 7.29299 15.2071L1.50009 9.41421C0.719046 8.63317 0.719044 7.36684 1.50009 6.58579L7.29299 0.792894C7.68351 0.402369 8.31668 0.402369 8.7072 0.792894C9.09772 1.18342 9.09772 1.81658 8.7072 2.20711L3.91431 7H18.0001C18.5524 7 19.0001 7.44772 19.0001 8C19.0001 8.55229 18.5524 9 18.0001 9H3.91431L8.7072 13.7929Z" fill="#131313"/>
    </svg>
  )
}

function BackButton({
  onClick
}) {
  return (
    <div className="BackBtn">
      <Button
        text="Back"
        color="white"
        Icon={() => <BackIcon />}
        onClick={onClick}
      />
    </div>
  )
}

export default BackButton;
